var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page page-error" }, [
    _c(
      "div",
      { staticClass: "container container-kernel main" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { lg: "4" } }, [
              _c("h1", { staticClass: "huge" }, [_vm._v(_vm._s(_vm.pageName))])
            ]),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { lg: "8" } },
              [
                _c("h2", { staticClass: "h2" }, [
                  _vm._v(
                    _vm._s(_vm.$t("errors.e" + _vm.pageName + ".title")) + " "
                  ),
                  _c("div", {
                    staticClass: "hi-man",
                    attrs: { id: "animation" }
                  })
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "h3" }, [
                  _vm._v(
                    _vm._s(_vm.$t("errors.e" + _vm.pageName + ".description"))
                  )
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("errors.webmaster")))]),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    attrs: {
                      to: { name: "Home" },
                      variant: "white",
                      "data-trackname": "errorBtn"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("buttons.gohome")))]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Error/Index.vue?vue&type=template&id=784da800&
// module id = null
// module chunks = 